// eslint-disable-next-line
import downloadIcon from '!!raw-loader!@img/download.svg';
import type { AttachmentToUploadMetaInfo } from '@generalTypes/apiTypes';
import { getAngularService } from '@kathondvla/react-shared-components/src/helpers/angularReactHelper';
import type { GlobalDocumentNode } from '@newStore/documentUI/documentUITypes';
import { replaceContentAttachmentOfGlobalDocument } from '@newStore/pendingActions/pendingActionsSagas';
import { getBase64 } from '@store/helpers/documentHelpers';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import uuidv4 from 'uuid/v4';
import './globalDocumentRow.scss';
import { openAside } from '@newStore/documentUI/documentUIState';
import { useTypedSelector } from '../../../../../hooks/useTypedSelector';
import AttachmentRow from '../attachmentRow/AttachmentRow';

const GlobalDocumentRow: React.FC<{ contentNode: GlobalDocumentNode }> = ({ contentNode }) => {
  const dispatch = useDispatch();
  const [embedUrl, setEmbedUrl] = useState(contentNode.embedUrl);

  const replaceAttachment = async () => {
    const opts = {
      component: 'browseFileModal',
      resolve: {
        modalHeaderTitle: () => `Nieuwe versie voor ${contentNode.title}`,
        browseLabel: () => 'Kies een nieuwe versie',
        content: () => ({ name: contentNode.attachmentName }),
      },
    };
    const modalWindowService = getAngularService('ModalWindowService');
    const response = await modalWindowService.open(opts);
    if (response) {
      const base64 = await getBase64(response);
      const newAttachment: AttachmentToUploadMetaInfo = {
        key: uuidv4(),
        type: 'CONTENT',
        name: response.name,
        size: response.size,
        $$base64: base64,
        isNew: true,
        created: new Date(),
        contentType: response.type,
      };
      dispatch(replaceContentAttachmentOfGlobalDocument({ newAttachment }));
      setEmbedUrl(base64);
    }
  };

  const isRoot = useTypedSelector((state) => state.documentUI.currentDocument === contentNode.href);

  if (!isRoot) {
    return <AttachmentRow contentNode={contentNode} />;
  }

  return (
    <div className="row-unstructured-document">
      <div className="button-row">
        <a
          className="download-link"
          href={contentNode.downloadUrl}
          target="_blank"
          download
          rel="noreferrer"
        >
          <span>{contentNode.attachmentName}</span>
          <span className="download-icon" dangerouslySetInnerHTML={{ __html: downloadIcon }} />
        </a>
        <button className="btn btn-purple btn-lg" onClick={replaceAttachment}>
          Vervangen
        </button>
      </div>

      {contentNode.previewPages.length === 0 && contentNode.isPdf && (
        <embed className="embeded-pdf" src={embedUrl} width="100%" height="1200px" />
      )}
      <div>
        {contentNode.previewPages.map((page) => (
          <img
            key={page.key}
            className="preview-img"
            src={page.src}
            onClick={() => dispatch(openAside({ href: contentNode.href }))}
          />
        ))}
      </div>
      {contentNode.previewPages.length === 0 && !contentNode.isPdf && (
        <div className="no-preview-msg">
          Er is nog geen preview beschikbaar voor dit document. <br />
          De preview wordt gegenereerd binnen het kwartier na het aanmaken of vervangen van een
          gedeeld document
        </div>
      )}
    </div>
  );
};

export default GlobalDocumentRow;
